module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    'turquoise': '#0EB8B6',
                    'darkgreen': '#044147',
                    'yellow': '#F9CE42',
                    'gray': '#F2F2F2',
                    'gray-400': '#918F91',
                }
            },
        },
        fontFamily: {
            adelleSans: ['Adelle Sans', 'sans-serif'],
            stolzl: ['Stolzl', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
